module.exports = __webpack_public_path__ + "static/img/m1_2.ee9f87b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/m1_2.png
// module id = S77W
// module chunks = 1